<input
  #uploadComponent
  id="{{ ppId }}"
  class="upload"
  accept="{{ ppAccept }}"
  type="file"
  [disabled]="ppDisabled"
/>
